<script>
  import PaddleListItem from '@/features/paddles/list/presentation/components/PaddleListItem'
  export default {
    name: 'paddles',
    components: {
      PaddleListItem,
    },
    data () {
      return {
        items: []
      }
    },
    methods: {
      getPaddles() {
        var json = require('@/assets/data/json/paddles/list/paddles.json');
        this.items = json
      }
    },
    mounted () {
      this.getPaddles()
    }
  }
</script>
<template>
  <b-container
    class="main-content mb-5">
    <b-row>
      <paddle-list-item
        v-for="item in items"
        :key="item.id"
        :item="item">
      </paddle-list-item>
    </b-row>
  </b-container>
</template>
